var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system-wrap"},[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"策划支持"}},[_c('scheme-config')],1),_c('TabPane',{attrs:{"label":"技术支持"}},[_c('footConfig')],1),_c('TabPane',{attrs:{"label":"公众号配置"}},[_c('wxConfig')],1),_c('TabPane',{attrs:{"label":"前端链接"}},[_c('frontLink')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }